import React from 'react'
import { useEffect } from 'react';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { getAbonementsList } from 'src/store/Slices/AbonementsSlice';
import MailingsContent from './Tables/MailingsContent';
import { mailingsContentListAction } from 'src/store/Slices/MailingsSlice';
import MailingsInfo from './Tables/MailingsInfo';
import ShowMailingDetail from './Modals/ShowMailingDetail';
import MobileMailingsPage from './MobileMailings/MobileMailingsPage';

const Mailings = ({ mnemo }) => {

    const dispatch = useDispatch()
    const [mailingsContent, setMailingsContent] = useState(null)
    const [mailingsInfo, setMailingsInfo] = useState(null)
    const [visible, setVisible] = useState({open: false})
    useEffect(() => {
        
    }, [visible])

    useEffect(() => {
        dispatch(mailingsContentListAction())
    }, [])

    useEffect(() => {
        
    }, [visible.open])
    useEffect(() => {
        
    }, [mailingsInfo])
    return (
        <>
        {visible.open === true && <ShowMailingDetail  visible={visible} setVisible={setVisible} mailInfo={mailingsInfo} mailingsContent={mailingsContent}/>}
            {window.innerWidth >= 768 ? <div>
                <MailingsContent mailingsContent={mailingsContent} setMailingsContent={setMailingsContent} mnemo={mnemo}/>
                {mailingsContent && <MailingsInfo mailingsContent={mailingsInfo} setMailingsContent={setMailingsInfo} mnemo={mnemo} setVisible={setVisible} mailingIdForUser={mailingsContent}/> }
                
                {/* <AbonementsGuide abonementInfo={abonementInfo} setAbonementInfo={setAbonementInfo} mnemo={mnemo} />
                {abonementInfo && <AbonementsCost mnemo={mnemo} abonementInfo={abonementInfo} abonementCostInfo={abonementCostInfo} setAbonementCostInfo={setAbonementCostInfo} />}
                {abonementCostInfo && <AbonementsServices mnemo={mnemo} abonementCostInfo={abonementCostInfo} />} */}
            </div> 
            : <MobileMailingsPage
                mnemo={mnemo}
                mailingsContent={mailingsContent}
                setMailingsContent={setMailingsContent}
                mailingsInfo={mailingsInfo}
                setMailingsInfo={setMailingsInfo}
                visible={visible}
                setVisible={setVisible}
            />
            }
        </>
    )
}

export default Mailings